<!--
FILTRO SELECAO DE MES

EVENTOS:
  monthChange(startDate, endDate)

COMO USAR:
    <div class="col-md-3 col-6">
        <input-month p-month="monthObj" @monthChange="monthChange"></input-month>
    </div>
-->

<template>
  <div class="align-items-center">
      <div class="form-group form-group-sm">
        <div class="input-group input-group-sm">
          <span class="input-group-append">
              <button v-if="showButtons" class="btn btn-sm btn-outline-secondary" @click="clickMesAnterior"
                  title="Mês Anterior">
                  <i class="fa fa-minus" aria-hidden="true"></i>
              </button>
          </span>

          <!-- <div class="form-control form-control-sm" v-if="showButtons" style="cursor: pointer; margin-right: 5px; width: 30px;"
              title="Mês Anterior"
              @click="clickMesAnterior()"><i class="fa fa-minus" aria-hidden="true"></i></div> -->

          <div class="form-control form-control-sm" data-toggle="dropdown" style="min-width: 150px; display: flex; justify-content: space-between;">
              <span>{{ monthString }}</span>
              <span class="dropdown-toggle" v-if="showOptions"></span>
          </div>

          <!-- <button class="btn btn-sm btn-outline-secondary dropdown-toggle" data-toggle="dropdown" style="min-width: 140px; border-radius: 0%" >{{ monthString }} <span class="caret"></span></button> -->
          <div class="dropdown-menu" v-if="showOptions">
              <a class="dropdown-item" href="#" v-for="action in options" :key="action.action"
                  @click="clickAction(action.action)">{{ action.label }}</a>
          </div>

          <span class="input-group-append">
              <button v-if="showButtons" class="btn btn-sm btn-outline-secondary" @click="clickProximoMes"
                  title="Próximo Mês">
                  <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
          </span>
          <!-- <div class="form-control form-control-sm" v-if="showButtons" style="cursor: pointer; margin-left: 5px; width: 30px;" title="Próximo Mês"
              @click="clickProximoMes()"><i class="fa fa-plus" aria-hidden="true"></i></div> -->
        </div>

        <div class="mt-3" v-if="inputingDates">
          <div class="dropdown-total col-md-12 col-12 mt-n3" style="padding: 15px; width: 250px">
              <button type="button" class="close" @click="inputingDates = false"><span aria-hidden="true">&times;</span></button>
              <div class="row">
                <div class="col-md-12 text-center">
                  <form-field ref="start" v-model="start" type="date" col="12" label="Data Inicial"></form-field>
                </div>
                <div class="col-md-12 text-center">
                  <form-field ref="end" v-model="end" type="date" col="12" label="Data Final"></form-field>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12 text-center">
                  <v-button label="Ok" title="" icon="fa-check" :nb-btdef="true" @click="handlePeriodo"></v-button>
                </div>
              </div>
          </div>
        </div>
      </div>



      <!--
      <input
        type="text"
        v-on:focus="selectAll"
        v-bind:value="lStartDate"
        v-on:input="updateValue($event.target.value)"
        ref="startDate">
      <input
        type="text"
        v-on:focus="selectAll"
        v-bind:value="lEndDate"
        v-on:input="updateValue($event.target.value)"
        ref="endDate">
      -->
  </div>
</template>

<script>
import { formatValue, formatDate } from '../shared/utils'

export default {
    props: {
      pMonth: { type: Object },
      showOptions: { type: Boolean },
    },

    data () {
      return {
        month: 0,
        year: 0,
        monthString: '',
        start: Date,
        end: Date,
        inputingDates: false,
        showButtons: true,
        options: [],
        listMonth: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      }
    },

    methods: {
      formatValue: function() {
        let v = this.$refs.valor.value
        this.$refs.valor.value = formatValue(this.$strToFloat(v, this.precision), this.precision)
        this.focused = false
      },

      handleMesAtual (data) {
        let today = new Date()
        if (data)
          today = this.$strToDate(data)

        this.year = Number(today.getFullYear())
        this.month = today.getMonth()
        this.monthString = this.listMonth[this.month] + '/' + this.year

        let m = this.month + 1
        this.end = this.$lastDay(this.year + '-' + m + '-01')
        this.start = this.$firstDay(this.year + '-' + m + '-01')
        this.pMonth.startDate = this.start
        this.pMonth.endDate = this.end
        this.inputingDates = false
        this.showButtons = true
      },

      handlePeriodo () {
        this.monthString = formatDate(this.start) + ' - ' + formatDate(this.end)
        this.pMonth.startDate = this.start
        this.pMonth.endDate = this.end
        this.inputingDates = false
        this.showButtons = false
      },

      clickAction (action) {
        //hoje
        if (action == 1) {
          const data = new Date();
          const dia = String(data.getDate()).padStart(2, '0');
          const mes = String(data.getMonth() + 1).padStart(2, '0');
          const ano = data.getFullYear();
          const dataAtual = ano + '-' + mes + '-' + dia;

          this.start = dataAtual
          this.end = dataAtual
          this.monthString = formatDate(dataAtual)
        }

        //mes atual
        if (action == 2) {
          this.handleMesAtual()
        }

        //semana atual
        if (action == 3) {
          this.showButtons = false
          this.inputingDates = false
          this.start = this.$getDate();
          this.end = this.$addDays(this.$getDate(), 7);
          this.monthString = formatDate(this.start) + ' - ' + formatDate(this.end)
        }

        //ultimos 30 dias
        if (action == 4) {
          this.showButtons = false
          this.inputingDates = false
          this.start = this.$addDays(this.$getDate(), -30)
          this.end = this.$addDays(this.$getDate(), -1)
          this.monthString = formatDate(this.start) + ' - ' + formatDate(this.end)
        }

        //mes específico
        if (action == 5) {
          this.inputingDates = true

          this.$nextTick(function () {
            this.$refs.start.focus()
          })
        }

        //intervalo de datas
        if (action == 6) {
          this.inputingDates = true

          this.$nextTick(function () {
            this.$refs.start.focus()
          })
        }

        this.pMonth.startDate = this.start
        this.pMonth.endDate = this.end
        this.$emit('monthChange', this.start, this.end)
      },

      clickProximoMes () {
        if (this.month == 11) {
          this.year++
          this.month = 0
        } else {
          this.month++
        }
        this.monthString = this.listMonth[this.month] + '/' + this.year
        let m = this.month + 1
        this.end = this.$lastDay(this.year + '-' + m + '-01')
        this.start = this.$firstDay(this.year + '-' + m + '-01')
        this.pMonth.startDate = this.start
        this.pMonth.endDate = this.end
        this.$emit('monthChange', this.start, this.end)
      },

      clickMesAnterior () {
        if (this.month == 0) {
          this.year--
          this.month = 11
        } else {
          this.month--
        }
        this.monthString = this.listMonth[this.month] + '/' + this.year
        let m = this.month + 1
        this.end = this.$lastDay(this.year + '-' + m + '-01')
        this.start = this.$firstDay(this.year + '-' + m + '-01')
        this.pMonth.startDate = this.start
        this.pMonth.endDate = this.end
        this.$emit('monthChange', this.start, this.end)
      },

    },

    created () {
      if (!this.pMonth.startDate)
        this.handleMesAtual()
      else {
        console.log(this.pMonth)
        this.handleMesAtual(this.pMonth.startDate)
      }

      if (this.showOptions) {
        var act = {}
        act = { action: 1, label: 'Hoje' }
        this.options.push(act)
        act = { action: 2, label: 'Este Mês' }
        this.options.push(act)
        act = { action: 3, label: 'Esta Semana' }
        this.options.push(act)
        act = { action: 4, label: 'Últimos 30 Dias' }
        this.options.push(act)
        act = { action: 5, label: 'Mês Específico' }
        this.options.push(act)
        act = { action: 6, label: 'Período Específico' }
        this.options.push(act)
      }
    },
}
</script>

<style scoped>

input {
  width: 100%;
}

.dropdown-total {
    z-index: 1051;
    margin-top: 3px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    position: absolute;
    padding: 10px;
    z-index: 1000;
    float: left;
    min-width: 160px;
    list-style: none;
    background-color: #fff;
    border: 1px solid #00000033;
    box-shadow: 0 5px 10px #00000033;
    background-clip: padding-box;
}

</style>



// WEBPACK FOOTER //
// src/components/input-month.vue